const comments = [
  {
    text: '每天打开今日看料已经成了习惯，内容更新快而且质量高，特别是每日黑料栏目太上头了！',
    author: '老用户·阿强',
  },
  {
    text: '朋友推荐的，说这里料最多，果然没让我失望。历史回顾功能也特别好用，翻以前的猛料超方便。',
    author: '新用户·小雨',
  },
  {
    text: '对比了好几个同类型的站，今日看料的界面最清爽，内容分类也合理，一看就是用心做的。',
    author: '资深读者·大鹏',
  },
  {
    text: 'App版本体验很不错，推送也很及时，不会错过任何重磅爆料。希望一直做下去！',
    author: 'App用户·柠檬',
  },
  {
    text: '从贴吧追过来的老粉了，看着今日看料一步步做大，内容越来越丰富，真心替它高兴。',
    author: '铁粉·老王',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3 tracking-tight">
          读者热评
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          来自真实用户的声音
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-5xl mx-auto">
          {comments.slice(0, 3).map((c, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200/60 transition-colors duration-200"
            >
              <div className="flex gap-1 mb-3">
                {[...Array(5)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-primary-400 text-xs"></i>
                ))}
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed mb-4">
                &ldquo;{c.text}&rdquo;
              </p>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-primary-600 text-xs font-bold">{c.author.charAt(0)}</span>
                </div>
                <span className="text-foreground-500 text-xs font-medium">{c.author}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl mx-auto mt-4">
          {comments.slice(3).map((c, i) => (
            <div
              key={i + 3}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200/60 transition-colors duration-200"
            >
              <div className="flex gap-1 mb-3">
                {[...Array(5)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-primary-400 text-xs"></i>
                ))}
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed mb-4">
                &ldquo;{c.text}&rdquo;
              </p>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-primary-600 text-xs font-bold">{c.author.charAt(0)}</span>
                </div>
                <span className="text-foreground-500 text-xs font-medium">{c.author}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}